module.exports = __webpack_public_path__ + "media/npc_dota_hero_earthshaker.d4dfc3b8.webm";